import { FC } from 'react';
import style from './AssignAnimalsForm.module.scss';
import { useAssignAnimalsContext } from '@/components/Samples/AssignAnimals/AssignAnimalsProvider';
import Radio from '@/components/UI/FormElements/Radio';
import { GroupSearchSelect } from './GroupSearchSelect';
import { PlannedSampleSearchSelect } from '@/components/Samples/AssignAnimals/PlannedSampleSearchSelect';
import { useAddSamplePlanContext } from '@/components/Samples/AddSamplePlanProvider';
import { RegisteredAnimalSearchSelect } from '@/components/Samples/AssignAnimals/RegisteredAnimalSearchSelect';
import { PlannedAnimalSearchSelect } from '@/components/Samples/AssignAnimals/PlannedAnimalSearchSelect';

const AssignAnimalsBy: FC = () => {
  const { groups, registered_animals } = useAddSamplePlanContext();
  const { activeTargetType, updateActiveTargetType, plannedAnimalsOptions } = useAssignAnimalsContext();
  return (
    <div className="flex flex-column mv2" data-test-component="AssignAnimalsBy" data-test-element="container">
      <div className="mb2 near-black">Assign samples using</div>
      <div className="flex flex-row items-center gap-h-2">
        {groups.size > 0 ? (
          <Radio
            id="group"
            name="assignBy"
            label="Group"
            value="group"
            dataTestId="group"
            checked={activeTargetType === 'groups'}
            onChange={() => updateActiveTargetType('groups')}
          />
        ) : null}
        {plannedAnimalsOptions.size > 0 ? (
          <Radio
            id="planned_animals"
            name="assignBy"
            label="Planned animals"
            value="planned_animals"
            dataTestId="planned_animals"
            checked={activeTargetType === 'planned_animals'}
            onChange={() => updateActiveTargetType('planned_animals')}
          />
        ) : null}
        {registered_animals.size > 0 ? (
          <Radio
            id="registered_animals"
            name="assignBy"
            label="Registered animals"
            value="registered_animals"
            dataTestId="registered_animals"
            checked={activeTargetType === 'registered_animals'}
            onChange={() => updateActiveTargetType('registered_animals')}
          />
        ) : null}
      </div>
    </div>
  );
};

const TargetSearchSelect: FC = () => {
  const { activeTargetType } = useAssignAnimalsContext();
  switch (activeTargetType) {
    case 'groups':
      return <GroupSearchSelect />;
    case 'registered_animals':
      return <RegisteredAnimalSearchSelect />;
    case 'planned_animals':
      return <PlannedAnimalSearchSelect />;
    default:
      return null;
  }
};

export const AssignAnimalsForm: FC = () => {
  return (
    <div className={style.Container} data-test-component="AssignAnimalsForm" data-test-element="container">
      <AssignAnimalsBy />
      <div className={style.GridContainer}>
        <TargetSearchSelect />
        <div data-test-element="planned-sample-column">
          <PlannedSampleSearchSelect />
        </div>
      </div>
    </div>
  );
};
